var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper-action row no-margin",
      on: {
        click: function($event) {
          return _vm.setPosSection("tables")
        }
      }
    },
    [
      _vm.tableInfo || _vm.table_number
        ? _c("div", { staticClass: "col status selected text-success" }, [
            _vm.tableInfo
              ? _c("strong", [
                  _c("i", {
                    staticClass: "fas fa-check",
                    staticStyle: { "margin-right": "3px" }
                  }),
                  _vm._v(" "),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("apps.pos.message.tablenumber", {
                          ref_name: _vm.refName,
                          number: _vm.tableInfo.table_number
                        })
                      ) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.tableInfo && _vm.table_number
              ? _c("strong", [
                  _c("i", {
                    staticClass: "fas fa-check",
                    staticStyle: { "margin-right": "3px" }
                  }),
                  _vm._v(" "),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("apps.pos.message.tablenumber", {
                          ref_name: _vm.refName,
                          number: _vm.table_number
                        })
                      ) +
                      "\n    "
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.tableInfo && !_vm.table_number
        ? _c("div", { staticClass: "col status" }, [
            _c("strong", [_vm._v("\n      " + _vm._s(_vm.refName) + "\n    ")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 text-right available" }, [
      _c("i", { staticClass: "fas fa-angle-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41152da2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41152da2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/TableButton.vue
// module id = null
// module chunks = 